import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import { validateDomain } from '../domain/validations.js';

export const domainBuy = (
  services: CommandServices,
  cliVersion: string,
  configSiteId?: string
) => {
  return createCommand('buy')
    .description('Buy a domain for your Wix account')
    .argument(
      '<domain>',
      'Domain to buy, including the TLD (for example, example.com)',
      validateDomain
    )
    .addOption(new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format'))
    .addHelpText(
      'after',
      [
        '',
        'Examples:',
        '  $ wix account domain buy example.com',
        '  $ wix account domain buy example.com --json',
        '  $ wix account --site-id <siteId> domain buy example.com',
      ].join('\n')
    )
    .action(async (domain, options, command) => {
      const { runCommand } = await import('../run-command.js');
      const { runBuyDomain } = await import('../domain/buy-domain.js');

      const { siteId } = command.optsWithGlobals() as { siteId?: string };

      await runCommand(command, services, cliVersion, () =>
        runBuyDomain(services, {
          domain,
          json: options.json,
          siteId: siteId ?? configSiteId,
        })
      );
    });
};
